// src/config.js
const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL,
  // Add other global configs here
  APP_NAME: process.env.REACT_APP_NAME,
  VERSION: process.env.REACT_APP_VERSION,
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
  SALES_EMAIL: process.env.REACT_APP_SALES_EMAIL,
  PRIVACY_EMAIL: process.env.REACT_APP_PRIVACY_EMAIL,
  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,
  COST_PER_PDF: process.env.REACT_APP_COST_PER_PDF
};

export default config;